
const format_date=(date_str)=>{

const date = new Date(date_str);

const formattedDate = date.toLocaleDateString('en-GB', {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit'
});

const [day, month, year] = formattedDate.split('/');
// const finalFormattedDate = `${year}.${month}.${day}`;
const finalFormattedDate = `${month}.${day}.${year}`;

return finalFormattedDate


}

const getdateOneYearFromDate=(date)=>
{
  const specificDate = date;
const dateParts = specificDate.split('-');
const year = parseInt(dateParts[0], 10);
const month = parseInt(dateParts[1], 10) - 1; // Months are zero-based
const day = parseInt(dateParts[2], 10);

// Create a date object from the specific date
const specificDateObj = new Date(year, month, day);

// Add one year to the specific date
specificDateObj.setFullYear(specificDateObj.getFullYear() + 1);

// Format the new date to 'YYYY-MM-DD'
const newYear = specificDateObj.getFullYear();
const newMonth = String(specificDateObj.getMonth() + 1).padStart(2, '0');
const newDay = String(specificDateObj.getDate()).padStart(2, '0');

const newFormattedDate = `${newMonth}-${newDay}-${newYear}`;

return newFormattedDate

}

export {format_date,getdateOneYearFromDate}

export function convertDate(dateStr) {
  // Parse the input string into a Date object
  const date = new Date(dateStr);

  // Extract day, month, hour, and minute from the date
  const day = String(date.getDate()).padStart(2, '0');  // Pad day to ensure it's two digits
  const month = date.toLocaleString('en-GB', { month: 'short' });  // Get abbreviated month name
  const hour = String(date.getHours()).padStart(2, '0');  // Pad hour to ensure it's two digits
  const minute = String(date.getMinutes()).padStart(2, '0');  // Pad minute to ensure it's two digits

  // Return the formatted date in the desired format
  return `${day} ${month} at ${hour}:${minute}`;
}